var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',{attrs:{"id":"city","plain":true,"options":this.cityDDL},on:{"change":_vm.onCityChange},model:{value:(_vm.selectedCity),callback:function ($$v) {_vm.selectedCity=$$v},expression:"selectedCity"}})
}
var staticRenderFns = []

export { render, staticRenderFns }